export const tinkMetal = {
  100: '#FDFDFF',
  200: '#FBFBFC',
  300: '#F5F6F7',
  400: '#EEF3F4',
  500: '#ECF1F2',
  600: '#DCE2E3',
  700: '#ABB1B2',
  800: '#7C888A',
  900: '#445153',
};
